import { render, staticRenderFns } from "./BalancesTabs.vue?vue&type=template&id=2ba8149b&scoped=true"
import script from "./BalancesTabs.vue?vue&type=script&lang=js"
export * from "./BalancesTabs.vue?vue&type=script&lang=js"
import style0 from "./BalancesTabs.vue?vue&type=style&index=0&id=2ba8149b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba8149b",
  null
  
)

export default component.exports